/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/api/emailTrackerApi"/>

import { get } from 'Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest';
import { handleError } from 'Core/Medius.Core.Web/Scripts/lib/errorHandling/errorHandler';
import { EmailEntryDto } from '../models/emailEntryDto';

interface EmailStatusQuery {
    importTrackingId?: string;
    documentId?: number;
}

export async function getEmailStatuses(documentId?: string | number, importTrackingId?: string | null): Promise<EmailEntryDto[]> {
	try {
		if (!documentId && !importTrackingId) return [];

		const query: EmailStatusQuery = {};
		if (importTrackingId) query.importTrackingId = importTrackingId; // only add when truthy
		if (documentId) {
			const docIdNumber = typeof documentId === 'string' ? parseInt(documentId) : documentId;
			if (!isNaN(docIdNumber) && docIdNumber > 0) query.documentId = docIdNumber;
		}

	const result = await get<EmailEntryDto[]>('remedium-api/emailtracker/statuses', query);
		return Array.isArray(result) ? result : [];
	} catch (e) {
		handleError(e);
		return [];
	}
}

